export function MinusIcon({ fill, ...rest }) {
  return (
    <svg {...rest} width='24' height='24' viewBox='0 0 24 24' fill={fill} xmlns='http://www.w3.org/2000/svg'>
      <path d='M6.5 12C6.5 11.8011 6.57902 11.6103 6.71967 11.4697C6.86032 11.329 7.05109 11.25 7.25 11.25H17.75C17.9489 11.25 18.1397 11.329 18.2803 11.4697C18.421 11.6103 18.5 11.8011 18.5 12C18.5 12.1989 18.421 12.3897 18.2803 12.5303C18.1397 12.671 17.9489 12.75 17.75 12.75H7.25C7.05109 12.75 6.86032 12.671 6.71967 12.5303C6.57902 12.3897 6.5 12.1989 6.5 12Z' />
    </svg>
  );
}
